// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos gerais */
.stats-page-container {
    padding: 2rem;
    font-family: Arial, sans-serif;
    background-color: #ffffff;
    min-height: 100vh;
  }
  
  .stats-error-message {
    color: #ffffff;
    text-align: center;
    font-weight: bold;
    font-size: 1.2rem;
  }
  
  .stats-title {
    color: #ffffff;
    text-align: center;
    margin-bottom: 2rem;
    font-size: 2.5rem;
    font-weight: bold;
  }
  
  /* Estilos dos cards */
  .stats-card {
    background: linear-gradient(135deg, #ffffff, #f1f3f6);
    border-radius: 15px;
    box-shadow: 0 4px 15px rgba(194, 29, 29, 0.1);
    padding: 1.5rem;
    margin-bottom: 2rem;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  
  .stats-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
  }
  
  /* Cores específicas para cada card */
  .stats-metrics-card {
    background: linear-gradient(135deg, #946b44, #2575fc);
    color: white;
  }
  
  .stats-site-card {
    background: linear-gradient(135deg, #01addd, #0072ff);
    color: white;
  }
  
  .stats-supervisor-card {
    background: linear-gradient(135deg, #7270fc, #1604dc);
    color: white;
  }
  
  .stats-equipment-card {
    background: linear-gradient(135deg, #2ebf91, #8360c3);
    color: white;
  }
  
  /* Estilos para listas */
  .stats-card ul {
    list-style-type: none;
    padding: 0;
  }
  
  .stats-card ul li {
    background-color: rgba(255, 255, 255, 0.1);
    margin: 0.5rem 0;
    padding: 0.75rem;
    border-radius: 8px;
    font-size: 1rem;
    color: white;
  }
  
  /* Títulos dentro dos cards */
  .stats-card h2 {
    margin-bottom: 1.5rem;
    font-size: 1.75rem;
    font-weight: bold;
  }
  
  /* Responsividade */
  @media (max-width: 768px) {
    .stats-page-container {
      padding: 1rem;
    }
  
    .stats-card {
      padding: 1rem;
    }
  
    .stats-title {
      font-size: 2rem;
    }
  
    .stats-card h2 {
      font-size: 1.5rem;
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/report.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA,sBAAsB;EACtB;IACE,qDAAqD;IACrD,mBAAmB;IACnB,6CAA6C;IAC7C,eAAe;IACf,mBAAmB;IACnB,qDAAqD;EACvD;;EAEA;IACE,2BAA2B;IAC3B,yCAAyC;EAC3C;;EAEA,qCAAqC;EACrC;IACE,qDAAqD;IACrD,YAAY;EACd;;EAEA;IACE,qDAAqD;IACrD,YAAY;EACd;;EAEA;IACE,qDAAqD;IACrD,YAAY;EACd;;EAEA;IACE,qDAAqD;IACrD,YAAY;EACd;;EAEA,wBAAwB;EACxB;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,0CAA0C;IAC1C,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,YAAY;EACd;;EAEA,6BAA6B;EAC7B;IACE,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA,mBAAmB;EACnB;IACE;MACE,aAAa;IACf;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,iBAAiB;IACnB;EACF","sourcesContent":["/* Estilos gerais */\n.stats-page-container {\n    padding: 2rem;\n    font-family: Arial, sans-serif;\n    background-color: #ffffff;\n    min-height: 100vh;\n  }\n  \n  .stats-error-message {\n    color: #ffffff;\n    text-align: center;\n    font-weight: bold;\n    font-size: 1.2rem;\n  }\n  \n  .stats-title {\n    color: #ffffff;\n    text-align: center;\n    margin-bottom: 2rem;\n    font-size: 2.5rem;\n    font-weight: bold;\n  }\n  \n  /* Estilos dos cards */\n  .stats-card {\n    background: linear-gradient(135deg, #ffffff, #f1f3f6);\n    border-radius: 15px;\n    box-shadow: 0 4px 15px rgba(194, 29, 29, 0.1);\n    padding: 1.5rem;\n    margin-bottom: 2rem;\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n  }\n  \n  .stats-card:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);\n  }\n  \n  /* Cores específicas para cada card */\n  .stats-metrics-card {\n    background: linear-gradient(135deg, #946b44, #2575fc);\n    color: white;\n  }\n  \n  .stats-site-card {\n    background: linear-gradient(135deg, #01addd, #0072ff);\n    color: white;\n  }\n  \n  .stats-supervisor-card {\n    background: linear-gradient(135deg, #7270fc, #1604dc);\n    color: white;\n  }\n  \n  .stats-equipment-card {\n    background: linear-gradient(135deg, #2ebf91, #8360c3);\n    color: white;\n  }\n  \n  /* Estilos para listas */\n  .stats-card ul {\n    list-style-type: none;\n    padding: 0;\n  }\n  \n  .stats-card ul li {\n    background-color: rgba(255, 255, 255, 0.1);\n    margin: 0.5rem 0;\n    padding: 0.75rem;\n    border-radius: 8px;\n    font-size: 1rem;\n    color: white;\n  }\n  \n  /* Títulos dentro dos cards */\n  .stats-card h2 {\n    margin-bottom: 1.5rem;\n    font-size: 1.75rem;\n    font-weight: bold;\n  }\n  \n  /* Responsividade */\n  @media (max-width: 768px) {\n    .stats-page-container {\n      padding: 1rem;\n    }\n  \n    .stats-card {\n      padding: 1rem;\n    }\n  \n    .stats-title {\n      font-size: 2rem;\n    }\n  \n    .stats-card h2 {\n      font-size: 1.5rem;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
